import React from "react";
import "./loadingComponent.scss";
export default function LoadingComponent() {
  return (
    <div className="pdf-tray-loading--spinner">
      <div></div>
      <div></div>
      <div></div>
      <span className="sr-only">Loading...</span>
    </div>
  );
}
